(function () {
  class LogosCarouselComponent extends HTMLElement {
    constructor() {
      super();

    }

    connectedCallback() {
      this.slider = this.querySelector('.embla');

      if (! this.slider) return;

      const options = {
        loop: true,
        align: this.slider.dataset.align || 'start',
      }

      const plugins = [];

      if (this.slider.dataset.autoplay === 'true') {
        plugins.push(EmblaCarouselAutoplay({
          delay: (parseInt(this.slider.dataset.speed) || 4) * 1000,
          stopOnInteraction: false,
          stopOnMouseEnter: true
        }))
      }

      EmblaCarousel(this.slider, options, plugins);
    }
  }
  if (!customElements.get('logos-carousel-component')) {
    customElements.define('logos-carousel-component', LogosCarouselComponent);
  }
})();
